import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var checkboxLabel = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1bn7u9q1',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_1bn7u9q2',small:'fx_2d2fb1e5_1bn7u9q3','default':'fx_2d2fb1e5_1bn7u9q4'}},defaultVariants:{size:'default'},compoundVariants:[]});
var checkboxLabelHorizontalGap = 'var(--fx_2d2fb1e5_1bn7u9q0)';

export { checkboxLabel, checkboxLabelHorizontalGap };
//# sourceMappingURL=label.vanilla.mjs.map
